import React, { useEffect, useState } from 'react';
import { Accordion, Col, Image, Row,Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import packageListingStyles from './packageListing.module.scss';
import useAxiosFetch from 'hooks/useAxiosFetch';
import { apiBackendBaseUrl, updateLookupDataUrl,templateAuthorisedID,defOrderedPackageGroupName } from 'utils/envsetup';
import useAxiosFunction from 'hooks/useAxiosFunction';
import axios from 'utils/axiosInstance';
import { useSelector } from 'react-redux';
import { TENANTIDTORESTRICT, USERIDTORESTRICT } from 'utils/constants';
import Feedback from 'components/Workspace/Feedback';
import OfferPopup from 'components/Workspace/OfferPopup';

const PackageListing = (props) => {
  const userId = useSelector(state => state.commonData?.userProfile?.userId);
  const tenantId = useSelector(state => state.commonData?.tenant?.tenantId);
  //console.log("userId::",userId)
  //console.log("tenantId::",tenantId)
  const [packageGrpOrdr, ,] = useAxiosFetch({
    endPoint: `${apiBackendBaseUrl}${defOrderedPackageGroupName}`,
    method: 'GET',
  });
  const [packageDtls, ,] = useAxiosFetch({
    endPoint: `${apiBackendBaseUrl}application/packagedatadtls/getpackagedatadtls`,
    method: 'GET',
  });
 

  const [responseLookIds, errorLookIds, loadingLookIds] = useAxiosFetch({
    endPoint: apiBackendBaseUrl + templateAuthorisedID,
    method: 'GET',
  });

  const [, , , axiosFetch] = useAxiosFunction();
  const [displayThanksPage, setThanksPageValue] = useState(false)
  const [packageDtlsList, setpackageDtlsList] = useState([]);
  const [groupOrder, setGroupOrder] = useState([]);
  const [activeKeyList, setActiveKeyList] = useState([]);
  useEffect(() => {
    const lookUpIdsArray = responseLookIds?.itemLabel?.split(';');
    lookUpIdsArray?.map(e => {
      const idsArray = e?.split('&');
      USERIDTORESTRICT?.push(idsArray[0]);
      TENANTIDTORESTRICT?.push(idsArray[1]);
      return null;
    });
  }, [responseLookIds, errorLookIds, loadingLookIds]);
  useEffect(() => {
    if (packageDtls && packageGrpOrdr) {
      const packageGroupOrderList = packageGrpOrdr?.itemLabel?.split(';')?.filter(item=>item!=="");
      setpackageDtlsList(packageDtls);
      setGroupOrder(packageGroupOrderList);
      }
  }, [packageDtls,packageGrpOrdr]);

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData('text/plain', index);
  };

  const handleDragOver = e => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = async (e, index) => {
    e.preventDefault();
    const tempList = [...groupOrder];
    const draggedFrom = e.dataTransfer.getData('text/plain');
    const draggedItem = tempList[draggedFrom];

    tempList.splice(draggedFrom, 1);
    tempList.splice(index, 0, draggedItem);
    setGroupOrder(tempList);
    const reOrderedGrp = tempList?.join(';') + ';';
    //console.log('reOrderedGrp', reOrderedGrp);
    await axiosFetch({
      axiosInstance: axios,
      method: 'POST',
      url: `${apiBackendBaseUrl}${updateLookupDataUrl}`,
      requestConfig: {
        ...packageGrpOrdr,
        itemLabel: reOrderedGrp,
      },
    });
  };

  const handlePackageDrop = async (e, index, grp) => {
    e.preventDefault();
    const tempList = packageDtlsList?.[grp];
    const draggedFrom = e.dataTransfer.getData('text/plain');
    const draggedItem = tempList[draggedFrom];
    const tempListNew = [...tempList];
    tempListNew.splice(draggedFrom, 1);
    tempListNew.splice(index, 0, draggedItem);
    const newList = { ...packageDtlsList, [grp]: tempListNew };
    setpackageDtlsList(newList);
    const idsList = tempListNew?.map(val => val?.packageId);
    //console.log('tempListNewpack', tempListNew, idsList);
    await axiosFetch({
      axiosInstance: axios,
      method: 'POST',
      url: `${apiBackendBaseUrl}application/packagedatadtls/dragpackagedatadtlspositions`,
      requestConfig: {
        groupName: grp,
        idsList: idsList,
      },
    });
  };

  const handleComponentClick = grp => {
    if (activeKeyList?.includes(grp)) {
      const arr = activeKeyList?.filter(e => e !== grp);
      setActiveKeyList(arr);
    } else {
      setActiveKeyList([...activeKeyList, grp]);
    }
  };

  return (
    <>
       {props.isFeedbackPopupShow && <Feedback isFeedbackPopupShow={props.isFeedbackPopupShow} setIsFeedbackPopupShow ={props.setIsFeedbackPopupShow} isFeedbackPopupSource={props.isFeedbackPopupSource} isFeedbackCapturedAt={props.isFeedbackCapturedAt} setThanksPageValue={setThanksPageValue} pageName={"WORKSPACE"}/>}
          { <OfferPopup setIsOfferPopupShow={props?.setIsOfferPopupShow}/>}
          <Modal
      style={{zIndex:"99999"}}
        show={displayThanksPage}
        onHide={() => {
          setThanksPageValue(false);
        }}
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body >
        <h3 style={{fontSize:'22px'}}>Thanks for sharing your feedback with us. <br/>Have a good day.</h3>
        </Modal.Body>
      </Modal>
      <Row>
        <Col lg={3}>
          <nav className={packageListingStyles['package-list-Navbar']}>
            <ul
            // style={{ paddingLeft: '0' }}
            >
              <p>
                <Link
                  to="/package-listing/packages"
                  className={packageListingStyles['package-list-link']}
                >
                  Packages
                </Link>
              </p>
            </ul>
          </nav>
        </Col>
        <Col lg={9}>
          <div style={{ display: 'flex' }}>
            <div style={{ flex: '1' }}>Name</div>&nbsp;&nbsp;&nbsp;&nbsp;
            <div style={{ flex: '1' }}>App Id</div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <div style={{ flex: '1' }}>Source App Name</div>&nbsp;&nbsp;
            <div style={{ flex: '1' }}>Published On</div>&nbsp;&nbsp;&nbsp;&nbsp;
            <div style={{ flex: '1' }}>Action</div>&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
          {groupOrder?.map((grp, i) => {
            return (
              <Accordion activeKey={activeKeyList}>
                <Accordion.Item eventKey={grp}>
                  <Accordion.Header
                    onClick={() => {
                      handleComponentClick(grp);
                    }}
                  >
                    <div style={{ display: 'flex' }}>
                      <div
                        draggable
                        onDragStart={e => handleDragStart(e, i)}
                        onDragOver={e => handleDragOver(e)}
                        onDrop={e => handleDrop(e, i)}
                      >
                        <Image
                          src="/assets/svg/page-template-Ico_Drag.svg"
                          style={{ cursor: 'grab', marginRight: '10px', marginLeft: '-30px' }}
                        />
                      </div>
                      <div>{grp}</div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    {packageDtlsList?.[grp]?.map((pckg, index) => {
                      const getDateAndTime = value => {
                        if (value < 10) {
                          return `0${value}`;
                        }
                        return value;
                      };
                      return (
                        <div style={{ display: 'flex' }}>
                          <div
                            draggable
                            onDragStart={e => handleDragStart(e, index)}
                            onDragOver={e => handleDragOver(e)}
                            onDrop={e => handlePackageDrop(e, index, grp)}
                          >
                            <Image
                              src="/assets/svg/page-template-Ico_Drag.svg"
                              style={{ cursor: 'grab', marginRight: '10px' }}
                            />
                          </div>
                          <div style={{ flex: '1' }}>{pckg?.packageName}</div>&nbsp;&nbsp;
                          <div style={{ flex: '1' }}>{pckg?.applicationId}</div>&nbsp;&nbsp;&nbsp;&nbsp;
                          <div style={{ flex: '1' }}>{pckg?.appName}</div>&nbsp;&nbsp;
                          <div style={{ flex: '1' }}>
                            {/* {pckg?.createdDate} */}
                            {pckg?.createdDate[0]}-{getDateAndTime(pckg?.createdDate[1])}-
                            {getDateAndTime(pckg?.createdDate[2])}&nbsp;
                            {getDateAndTime(pckg?.createdDate[3])}:
                            {getDateAndTime(pckg?.createdDate[4])}:
                            {getDateAndTime(pckg?.createdDate[5])}
                          </div>
                          <div style={{ flex: '1' }}>
                         {USERIDTORESTRICT?.includes(userId) &&  TENANTIDTORESTRICT?.includes(tenantId)?<i
                              className="icon-ico_delete"
                              onClick={async () => {
                                const newList = [...packageDtlsList?.[grp]];
                                newList?.splice(index, 1);
                                const newPackageDtlsObj = {
                                  ...packageDtlsList,
                                  [grp]: newList,
                                };
                                //console.log('newListpackage', newList, index, newPackageDtlsObj);
                                setpackageDtlsList(newPackageDtlsObj);
                                await axiosFetch({
                                  axiosInstance: axios,
                                  method: 'POST',
                                  url: `${apiBackendBaseUrl}application/packagedatadtls/deletepackagedatadtlsbyid`,
                                  requestConfig: { packageId: pckg?.packageId },
                                });
                              }}
                            ></i>:null}
                          </div>
                        </div>
                      );
                    })}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            );
          })}
        </Col>
      </Row>
    </>
  );
};
export default PackageListing;
